export default "__VITE_PUBLIC_ASSET__cb376da1__"